<script setup>
defineProps({ blok: Object });
</script>

<template>
  <v-row>
    <v-col cols="12" md="6">
      <StoryblokComponent
        v-for="content in blok.columnOne"
        :blok="content"
        :key="content._uid"
      />
    </v-col>
    <v-col cols="12" md="6">
      <StoryblokComponent
        v-for="content in blok.columnTwo"
        :blok="content"
        :key="content._uid"
      />
    </v-col>
  </v-row>
</template>
